import template from "./average_daily_vault_balance.html";
import controller from "./average_daily_vault_balance.controller";
import "./average_daily_vault_balance.scss";

let branchManagementAverageDailyVaultBalanceComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};
export default branchManagementAverageDailyVaultBalanceComponent;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/average-daily-vault-balance/average_daily_vault_balance.component.js